export default __webpack_public_path__ + "static/let-ai-m-f6a6293010bd757876626ed4b141ff0e.webp";